import { render, staticRenderFns } from "./DesignatedAudit.vue?vue&type=template&id=656ece8c&scoped=true"
import script from "./DesignatedAudit.vue?vue&type=script&lang=js"
export * from "./DesignatedAudit.vue?vue&type=script&lang=js"
import style0 from "./DesignatedAudit.vue?vue&type=style&index=0&id=656ece8c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ece8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('656ece8c')) {
      api.createRecord('656ece8c', component.options)
    } else {
      api.reload('656ece8c', component.options)
    }
    module.hot.accept("./DesignatedAudit.vue?vue&type=template&id=656ece8c&scoped=true", function () {
      api.rerender('656ece8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/PODVerification/component/DesignatedAudit.vue"
export default component.exports